import { anyPass, startsWith, endsWith, both, complement, test } from 'ramda'

export const sidecarDomains = ['sidecarhealth.com']

export const isSidecarDomain = anyPass(
  sidecarDomains.map(domain =>
    test(new RegExp(`^([\\w-]+\\.)?${domain}`, 'gi')),
  ),
)

export const isLocal = anyPass([
  startsWith('localhost'),
  startsWith('10.'), // when sharing dev servers
  startsWith('192.'), // when testing shared dev servers
  endsWith('ngrok-free.app'),
])

export const isDev = host => {
  // APP_ENV takes priority — short-circuits hostname sniffing entirely
  if (process.env.APP_ENV) return process.env.APP_ENV === 'dev'

  if (both(isSidecarDomain, startsWith('dev-'))(host)) return true

  return false
}

export const isQA = host => {
  // APP_ENV takes priority — short-circuits hostname sniffing entirely
  if (process.env.APP_ENV) return process.env.APP_ENV === 'qa'

  if (both(isSidecarDomain, startsWith('qa-'))(host)) return true

  return false
}

export const isProd = host => {
  // APP_ENV takes priority — short-circuits hostname sniffing entirely
  if (process.env.APP_ENV)
    return (
      process.env.APP_ENV === 'prod' || process.env.APP_ENV === 'production'
    )

  if (both(isSidecarDomain, complement(anyPass([isLocal, isDev, isQA])))(host))
    return true

  return false
}

export const getEnv = host => {
  if (isSidecarDomain(host)) {
    if (host.includes('-')) {
      return host.split('-')[0]
    } else {
      return 'prod'
    }
  }
  return 'n/a'
}
